import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import AddressIcon from '../../../../common/icons/addressIcon';
import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import { useSelector } from 'react-redux';
import AddressForm from './AddressForm';
import { market } from '../../../../../constants';
import { APP_SETTINGS } from '../../../../../settings/AppSettings';

const { CHILE } = APP_SETTINGS.COUNTRIES;

const AddressView = ({ ...props }) => {
  const { mobile } = props;
  const { addresses, billingAdresses } = useSelector(
    (state) => state.addressesReducer,
  );

  const addressSorter = (innerAddresses) => {
    if (!innerAddresses.length) return [];
    return [...innerAddresses].sort((a, b) => {
      if (a.primary > b.primary) return -1;
      else if (a.primary < b.primary) return 1;
      return 0;
    });
  };

  return (
    <React.Fragment>
      <ProfileTitle
        mobile={mobile}
        title="Direcciones"
        subtitle="Aquí podrás agregar tus direcciones de despacho y/o facturación"
        icon={<AddressIcon size="30px" color="#6A148E" />}
      />
      <Box>
        <AddressForm
          mobile={mobile}
          addresses={addressSorter(addresses)}
          title="Direcciones de despacho"
          subtitle="Ingresa la dirección en la que quieres recibir tu(s) compra(s)."
        />
        {market === CHILE.SHORT_NAME && (
          <AddressForm
            mobile={mobile}
            addresses={billingAdresses}
            title="Direcciones de facturación"
            subtitle="Ingresa la dirección en la que quieres recibir la facturación de tu cuenta."
            isBillAddress={true}
          />
        )}
      </Box>
    </React.Fragment>
  );
};

AddressView.propTypes = {
  mobile: PropTypes.bool,
};

export default AddressView;
